module.exports = __webpack_public_path__ + "img/icon-list-view.8c325654.svg";